import { IClient } from '../types/Client'
import { AccountClient } from './accountClient'
import { AddressfinderClient } from './addressfinderClient'
import { ArticlesClient } from './articlesClient'
import { AuthClient } from './authClient'
import { BladeClient } from './bladeClient'
import { CartClient } from './cartClient'
import { CheckoutClient } from './checkoutClient'
import { CMSClient } from './cmsClient'
import { ListsClient } from './listsClient'
import { OrderClient } from './orderClient'
import { ProductsClient } from './productsClient'
import { ProjectsClient } from './projectsClient'
import { ReviewClient } from './reviewClient'
import { SearchResultClient } from './searchClient'
import { StoreClient } from './storeClient'

export const Client: IClient = {
  cms: new CMSClient(),
  cart: new CartClient(),
  checkout: new CheckoutClient(),
  account: new AccountClient(),
  auth: new AuthClient(),
  order: new OrderClient(),
  productList: new ProductsClient(),
  projectList: new ProjectsClient(),
  articleList: new ArticlesClient(),
  store: new StoreClient(),
  searchResults: new SearchResultClient(),
  lists: new ListsClient(),
  blade: new BladeClient(),
  addressfinder: new AddressfinderClient(),
  reviews: new ReviewClient(),
}
